import { useEffect, useCallback } from 'react';
import * as XLSX from 'xlsx';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

const ReporteClientesSinPrestamoExcel = ({ clientes, onComplete }) => {
  const generateExcel = useCallback(() => {
    const formatDate = (date) => {
      if (!date) return 'N/A';
      try {
        return format(parseISO(date), 'dd/MM/yyyy', { locale: es });
      } catch (error) {
        return 'N/A';
      }
    };

    const formatCurrency = (amount) => {
      if (!amount) return 'S/. 0.00';
      return `S/. ${parseFloat(amount).toFixed(2)}`;
    };

    const getEstadoText = (estadoCliente) => {
      if (estadoCliente === 'sin_prestamo_activo') {
        return 'SIN PRÉSTAMO ACTIVO';
      } else if (estadoCliente === 'sin_registro_prestamos') {
        return 'SIN REGISTRO DE PRÉSTAMOS';
      }
      return estadoCliente;
    };
    const datosExcel = clientes.map((cliente, index) => ({
      'N°': index + 1,
      'Cliente': cliente.nombre_completo,
      'DNI': cliente.datos?.numero_documento || 'N/A',
      'Estado': getEstadoText(cliente.estado_cliente),
      'Monto Último Préstamo': cliente.ultimo_prestamo
        ? formatCurrency(cliente.ultimo_prestamo.monto_prestamo)
        : 'Sin préstamos',
      'Tasa %': cliente.ultimo_prestamo
        ? `${Number(cliente.ultimo_prestamo.tasa_interes || 0).toFixed(2)}%`
        : 'N/A',
      'Última Cuota Pagada': cliente.ultimo_prestamo?.ultima_cuota_pagada
        ? `Cuota ${cliente.ultimo_prestamo.ultima_cuota_pagada.numero_cuota} - ${formatDate(cliente.ultimo_prestamo.ultima_cuota_pagada.fecha_pago)}`
        : 'N/A',
      'Teléfono': cliente.contacto?.telefono || 'N/A',
      'Dirección': cliente.direccion_completa || 'N/A',
      'Email': cliente.email || 'N/A',
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(datosExcel);

    const colWidths = [
      { wch: 5 },
      { wch: 30 },
      { wch: 12 },
      { wch: 25 },
      { wch: 20 },
      { wch: 10 },
      { wch: 25 },
      { wch: 15 },
      { wch: 40 },
      { wch: 25 },
    ];
    ws['!cols'] = colWidths;
    XLSX.utils.book_append_sheet(wb, ws, 'Clientes Sin Préstamo');

    const fechaActual = format(new Date(), 'dd-MM-yyyy_HH-mm', { locale: es });
    const nombreArchivo = `Clientes_Sin_Prestamo_Activo_${fechaActual}.xlsx`;

    XLSX.writeFile(wb, nombreArchivo);

    if (onComplete) {
      onComplete();
    }
  }, [clientes, onComplete]);

  useEffect(() => {
    if (clientes && clientes.length > 0) {
      generateExcel();
    }
  }, [clientes, generateExcel]);

  return null;
};

export default ReporteClientesSinPrestamoExcel;
